<template>
  <div class="vehicle-notes" id="vehicle-notes-window" :class="{ show: show }">
    <div class="vehicle-notes-content">
      <div class="vehicle-notes-heading">
        <fieldset>
          <legend class="d-flex justify-content-between">
            Notes

            <div>
              <button
                type="button"
                class="btn btn-primary btn-xs"
                @click="close"
              >
                <i class="material-icons">
                  cancel
                </i>
              </button>
            </div>
          </legend>
        </fieldset>

        <fieldset>
          <legend>New Note</legend>
          <div class="notes-input">
            <input-block
              placeholder="Note..."
              :stacked="true"
              name="note"
              v-model="form.body"
            ></input-block>
          </div>

          <form-button :indicator="form.processing()" v-on:clicked="save">
            Save Note
          </form-button>
        </fieldset>
      </div>

      <div class="vehicle-notes-body">
        <div class="note" v-for="(note, index) in vehicle.notes" :key="index">
          <p v-html="note.body"></p>

          <strong>
            {{ note.user?.full_name }} |
            {{ note.created_at | date('DD/MM/YYYY HH:mm') }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },

  data() {
    return {
      form: new window.Form(
        {
          body: ''
        },
        true
      ),
      sidebar: null
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  mounted() {
    const notes = document.getElementById('vehicle-notes-window');

    if (notes) {
      this.sidebar = new window.Ps(notes);
    }
  },

  updated() {
    if (this.sidebar) {
      this.sidebar.update();
    } else {
      const notes = document.getElementById('vehicle-notes-window');

      if (notes) {
        this.sidebar = new window.Ps(notes);
      }
    }
  },

  methods: {
    save() {
      this.form
        .post(
          `/fleet/${this.user?.tenant?.identifier}/${this.vehicle.identifier}/notes`
        )
        .then(data => {
          this.$emit('saved', data);

          window.toastify.success('Saved!', 'The note was saved successfully');
        })
        .catch(err => {
          console.error(err);

          window.toastify.error(
            'Error',
            'An error occurred while saving the note'
          );
        });
    },

    close() {
      this.$emit('closed');
    }
  },

  beforeDestroy() {
    if (this.sidebar) {
      this.sidebar.destroy();

      this.sidebar = null;
    }
  },

  watch: {
    vehicle(changed) {}
  }
};
</script>

<style lang="scss">
.vehicle-notes {
  position: fixed;
  z-index: 10;
  transition: all 0.5s ease;
  top: 0;
  right: 0;
  width: 0;
  background-color: #ffffff;
  height: 100%;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12), 0 1px 6px 0 rgba(0, 0, 0, 0.12);
  border-left: 1px solid #d3e0e9;
  overflow: hidden;

  .vehicle-notes-content {
    width: 100vw;
    padding: 30px;
    display: flex;
    flex-direction: column;

    .vehicle-notes-heading {
      flex-grow: 0;
      border-bottom: 1px solid #d3e0e9;
      padding-bottom: 15px;
      margin-bottom: 15px;
    }

    .vehicle-notes-body {
      flex-grow: 1;
      overflow-y: scroll;
      height: 100%;

      .note {
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12),
          0 1px 6px 0 rgba(0, 0, 0, 0.12) !important;
        padding: 15px;
        border: 1px solid #d3e0e9;
        margin-bottom: 25px;
      }
    }

    .notes-input {
      .form-group {
        display: block;
      }

      textarea {
        width: 100%;
        height: 80px;
      }
    }
  }

  &.show {
    width: 100%;
  }

  @media (min-width: 768px) {
    .vehicle-notes-content {
      width: 700px;
    }

    &.show {
      width: 700px;
    }
  }
}
</style>
